import { Stack } from "@fluentui/react";
import React, { ReactNode } from "react";

type TableFilterProps = React.PropsWithChildren<{
    children: ReactNode;
}>;

export const TableFilter: React.FC<TableFilterProps> = (props: TableFilterProps) => (
    <Stack styles={{ root: { paddingTop: 15 } }}>{props.children}</Stack>
);
